import {connect} from "react-redux";
import * as AddPeopleActions from '../../../store/actions/addPeopleActions';
import * as CoursesActions from '../../../store/actions/coursesActions';
import PeopleAdd from '../../../components/AdminPanel/People/PeopleAdd';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.requests,
    ...state.courses
});

const mapDispatchToProps = (dispatch) => ({
    onLoadCourses: (uid, token) => {
        dispatch(CoursesActions.getCoursesForAdmin(uid, token));
    },
    addUserToCourse: (courseUser, uid, token) => {
        dispatch(CoursesActions.addCourseUser(courseUser, uid, token));
    },
    getPendingRequests: (token) => {
        dispatch(CoursesActions.getPendingRequests(token));
    },
    updateCourses: (courses, uid, cu, token) => {
        dispatch(CoursesActions.updateCourses(courses, uid, cu, token));
    },
    getRequestsData: () => {
        dispatch(AddPeopleActions.getRequests());
    },
    addPeople: (user) => {
        dispatch(AddPeopleActions.addNewPeople(user))
    },
    cancelRequests: (id, token) => {
        dispatch(CoursesActions.removeCourseUser(id, token))
    },
    approveRequest: (id, token) => {
        dispatch(CoursesActions.approveRequest(id, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PeopleAdd);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/People/PeopleAddContainer.js